<template>
  <section class="characters-root">
    <div
      v-for="item in charactersArr"
      :key="item.id"
      class="character-con"
      :style="{ width: `${strokeFontSize}px`, height: `${strokeFontSize}px` }"
    >
      <svg xmlns="http://www.w3.org/2000/svg" :id="item.id">
        <line
          x1="0"
          y1="0"
          :x2="strokeFontSize"
          :y2="strokeFontSize"
          stroke-dasharray="4 5"
          stroke="#e9e9ec"
        ></line>
        <line
          :x1="strokeFontSize"
          y1="0"
          x2="0"
          :y2="strokeFontSize"
          stroke-dasharray="4 5"
          stroke="#e9e9ec"
        ></line>
        <line
          :x1="halfStrokeFontSize"
          y1="0"
          :x2="halfStrokeFontSize"
          :y2="strokeFontSize"
          stroke-dasharray="4 5"
          stroke="#e9e9ec"
        ></line>
        <line
          x1="0"
          :y1="halfStrokeFontSize"
          :x2="strokeFontSize"
          :y2="halfStrokeFontSize"
          stroke-dasharray="4 5"
          stroke="#e9e9ec"
        ></line>
      </svg>
    </div>
  </section>
</template>
<script>
import HanziWriter from 'hanzi-writer'
import axios from 'axios'
import { IS_CHINA } from '@/config'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showSmallSize: false,
      charactersArr: [],
      count: 0,
    }
  },
  watch: {
    currentItem: {
      handler() {
        this.count++
        if (this.currentItem?.characters) {
          let temp = Array.from(this.currentItem?.characters)
          this.charactersArr = temp.map((item, index) => {
            console.log(item, index)
            return {
              char: item,
              id: `character_${index}${this.currentItem.id}_${this.count}`,
            }
          })
          this.createrWriter()
        }
      },
      immediate: true,
    },
  },
  computed: {
    isChina() {
      return IS_CHINA
    },
    strokeFontSize() {
      const characterLength = this.charactersArr.length || 1
      if (characterLength > 2) {
        //容器宽度300px
        return this.showSmallSize
          ? Number((150 / characterLength).toFixed(0))
          : Number((300 / (characterLength < 5 ? characterLength : 5)).toFixed(0))
      } else {
        return this.showSmallSize ? 60 : 160
      }
    },
    halfStrokeFontSize() {
      return Number.parseInt(this.strokeFontSize / 2)
    },
  },
  methods: {
    createrWriter() {
      let _this = this

      this.$nextTick(() => {
        console.log(this.charactersArr)
        this.charactersArr.forEach((item) => {
          HanziWriter.create(item.id, item.char, {
            width: this.strokeFontSize,
            height: this.strokeFontSize,
            padding: 10,
            charDataLoader: function (char, onComplete) {
              axios
                .get(
                  (_this.isChina
                    ? _this.$store.state.publicUrl.mockPublicUrl
                    : 'https://public.hskmock.com') +
                    '/hanzi.static/' +
                    char +
                    '.json',
                  { timeout: 60000 }
                )
                .then((charData) => {
                  onComplete(charData.data)
                })
                .catch((err) => {
                  console.log(err)
                })
            },
          })
        })
      })
    },
  },
  mounted() {
    // console.log(this.currentItem, 'currentItem')
    // this.createrWriter()
  },
}
</script>
<style lang="scss" scoped>
.characters-root {
  display: flex;
}
.character-con {
  background-color: #fafafb;
  border-radius: 4px;
  border: 1px solid #e9e9ec;
  margin-left: 5px;
}
</style>
